import React, { FC } from 'react';
import styled from 'styled-components';
import { animated, useSpring } from 'react-spring';
import { GameCondition, getColorBySector, getFactorBySector } from '../../../../utils';

interface IGameRoulettePointer {
  sector: number;
  condition: GameCondition;
}

const from = {
  opacity: 0,
  transform: 'scale(0.75)',
};

const to = {
  opacity: 1,
  transform: 'scale(1)',
};

export const GameRoulettePointer: FC<IGameRoulettePointer> = ({ condition, sector }) => {
  const styles = useSpring({
    from,
    to: GameCondition.RESULT === condition ? to : from,
    reset: true,
  });

  return (
    <Container>
      <animated.div className={`indicator sector-${getColorBySector(sector)}`} style={styles}>
        x{getFactorBySector(sector)}
      </animated.div>
      <i className="icon-cursor" />
    </Container>
  );
};

const Container = styled.div`
  display: grid;
  grid-auto-flow: row;
  grid-template-columns: 2.25rem;
  grid-auto-rows: min-content;
  grid-gap: 0.75rem;
  align-content: flex-end;
  width: min-content;
  height: calc(min(100vw, 100vh) * 0.34);
  transform: translate3d(-50%, 0, 0);
  position: relative;
  z-index: 15;

  @media screen and (min-width: 500px) {
    height: 200px;
  }

  & .indicator {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 2.25rem;
    height: 1.375rem;
    background: var(--stroke-color);
    border-radius: var(--size-radius-s);

    font-weight: bold;
    font-size: 0.875rem;
    line-height: 1rem;
    letter-spacing: 0.13058px;
    color: var(--color-white);
  }

  & i {
    font-size: 2.25rem;
    transform: rotate(90deg);
    color: var(--color-white);
  }
`;
